// extracted by mini-css-extract-plugin
var _1 = "LoadableButton__disabled--ugr1h";
var _2 = "LoadableButton__loading--GwUON";
export { _1 as "disabled", _2 as "loading" }
